var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classList},[_c('div',[_vm._v(_vm._s(_vm.displayStartTime)+"–"+_vm._s(_vm.displayEndTime))]),(_vm.detail)?_c('div',{staticClass:"availability-button__detail"},[_vm._v(_vm._s(_vm.detail))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }